import React from "react";
import { Link } from "react-router-dom";
import LessonTable from "../components/LessonTable";
import { useState, useEffect } from "react";

/**
 * Maneuverpage
 *
 * Holds links to flight and ground training documents and videos.
 * Add new links here as they are created.
 */
export default function Maneuverpage() {

  /**
   * ------------------------------------------------------------
   * Maneuver lessons state
   * ------------------------------------------------------------
   */
  const [lessons, setLessons] = useState([]);
  const [maneuverId, setManeuverId] = useState("");
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [message, setMessage] = useState("");
  const [selectedManeuverId, setSelectedManeuverId] = useState("");



  /**
   * ------------------------------------------------------------
   * Load maneuver lesson data
   * ------------------------------------------------------------
   */
  useEffect(() => {

    async function loadLessons() {

        try {

        /**
         * --------------------------------------------------------
         * Fetch maneuver data from server
         * --------------------------------------------------------
         */
        const response = await fetch(
          "https://toldcardserver.vercel.app/api/maneuvers"
        );

        const data = await response.json();
        console.log("LOAD Get RESPONSE:", data);

        /**
         * --------------------------------------------------------
         * Store lessons in React state
         * --------------------------------------------------------
         */
        setLessons(data.lessons || []);

      } catch (err) {

        console.error(err);

      }
    }

    loadLessons();

  }, []);

      /**
       * ------------------------------------------------------------
       * Delete maneuver lesson
       * ------------------------------------------------------------
       */
      async function deleteManeuver(maneuverId) {

        if (!window.confirm(
          `Delete maneuver ${maneuverId}?`
        )) {
          return;
        }

        try {

          const response = await fetch(
            `https://toldcardserver.vercel.app/api/maneuvers?maneuverId=${maneuverId}`,
            {
              method: "DELETE",
            }
          );

          const data = await response.json();
          console.log("DELETE RESPONSE:", data);

          if (!response.ok) {
            throw new Error(data.error || "Delete failed");
          }

          alert("Maneuver deleted.");

          setLessons((prev) =>
            prev.filter(
              (lesson) => lesson.maneuverId !== maneuverId
            )
          );

        } catch (err) {

          alert(err.message);

        }
      }

      async function uploadManeuver(e) {

        e.preventDefault();

        const formData = new FormData();

        formData.append("maneuverId", maneuverId);
        formData.append("title", title);
        formData.append("category", category);
        formData.append("sortOrder", sortOrder);
        formData.append("image", imageFile);
        formData.append("pdf", pdfFile);

        try {

          const response = await fetch(
            "https://toldcardserver.vercel.app/api/maneuvers",
            {
              method: "POST",
              body: formData,
            }
          );

          const data = await response.json();

          if (!response.ok) {
            throw new Error(data.error || "Upload failed");
          }

          setMessage("Maneuver lesson uploaded.");
          alert("Maneuver lesson uploaded successfully.");

          // easiest way to refresh table
          window.location.reload();

        } catch (err) {

          setMessage(err.message);

        }
      }
      async function updateManeuver(e) {
          e.preventDefault();

          if (!selectedManeuverId) {
            alert("Select a lesson first.");
            return;
          }

        const formData = new FormData();

        formData.append("maneuverId", selectedManeuverId);
        formData.append("title", title);
        formData.append("category", category);
        formData.append("sortOrder", sortOrder);

        if (imageFile) {
          formData.append("image", imageFile);
        }

        if (pdfFile) {
          formData.append("pdf", pdfFile);
        }

        const response = await fetch(
          "https://toldcardserver.vercel.app/api/maneuvers",
          {
            method: "PUT",
            body: formData,
          }
        );

        const data = await response.json();
        console.log("UPDATE RESPONSE:", data);

        if (!response.ok) {
          console.error("UPDATE FAILED:", data);
          alert(data.error || "Update failed");
          return;
        }

        alert("Maneuver lesson updated.");

        setLessons((prev) =>
          prev.map((lesson) =>
            lesson.maneuverId === data.maneuver.maneuverId
              ? data.maneuver
              : lesson
          )
        );
      }
    


  return (
    <main className="tool-page">
      {/* ============================================================
          RELATED TOOLS / INTERNAL LINKS
          ============================================================ */}
          <div className="tool-content">
          <h2 >Related Tools</h2>
      
              <p >
                <Link to="/density-altitude">Density Altitude</Link> |
                <Link to="/cw">Crosswind/Headwind</Link> |
                <Link to="/mnvr">Maneuvers</Link> |
                <Link to="/airframe-powerplant">Airframe & Powerplant</Link> |
                <Link to="/airplane-prebuy">Airplane Prebuy Checklist</Link>
              </p>
          </div>
      <section className="tool-card">
        <h1>Flight Maneuvers</h1>
        <p 
        style={{ 
          fontSize: "22px", 
          fontWeight: "bold" 
          }}>
          This page contains links to lessons for flight maneuvers,
          ground reference maneuvers, takeoffs, landings, and other
          aviation training topics.
        </p>
        <h3>
          Selected Lesson: {selectedManeuverId || "None"}
        </h3>

        <form 
        onSubmit={uploadManeuver}
        className="maneuver-upload-form"
        >

          <h2 style={{ fontSize: "24px" }}>
              {selectedManeuverId ? "Edit Maneuver Lesson" : "Add Maneuver Lesson"}
            </h2>

            {selectedManeuverId && (
              <p style={{ fontWeight: "bold", color: "green" }}>
                Editing: {title}
              </p>
            )}

          <input
            type="text"
            placeholder="Maneuver ID"
            value={maneuverId}
            onChange={(e) => setManeuverId(e.target.value)}
          />

          <input
            type="text"
            placeholder="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />

          <input
            type="text"
            placeholder="Category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          />

          <input
            type="number"
            placeholder="Sort Order"
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
          />

          <div className="maneuver-file-row">
              <label>Lesson Img</label>
              <input
                type="file"
                accept="image/png,image/jpeg"
                onChange={(e) => setImageFile(e.target.files[0])}
              />
          </div>

          <div className="maneuver-file-row">
           <label>Lesson PDF</label>
          <input
            type="file"
            accept="application/pdf"
            onChange={(e) => setPdfFile(e.target.files[0])}
              />
          </div>
          <div className="maneuver-button-row">
              <button 
              type="submit"
              className="maneuver-upload-btn"
              >
                {selectedManeuverId ? "Add New Lesson" : "Upload Lesson"}
              </button>

              <button 
              type="button" 
              onClick={updateManeuver}
              >
                  Save Edit
                </button>
          </div>

          {message && <p>{message}</p>}

        </form>

        {/* ========================================================
            Lesson table.  OnEdit sets selectedManeuverId, 
            which is used to determine which lesson to update when Update Files is clicked.
            It is not the entire object.
            ======================================================== */}
        <div className="App-weather">
          <LessonTable 
          lessons={lessons}
          onDelete={deleteManeuver} 
           onEdit={(lesson) => {
                  console.log("EDIT CLICKED:", lesson);
                  setSelectedManeuverId(lesson.maneuverId);
                  setManeuverId(lesson.maneuverId || "");
                  setTitle(lesson.title || "");
                  setCategory(lesson.category || "");
                  setSortOrder(lesson.sortOrder || "");
              }}
          />
        </div>

        
      </section>
    </main>
  );
}